(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("video-testimonial-card")) {
    class VideoTestimonialCard extends HTMLElement {
      constructor() {
        super();
        this.videoType = this.dataset.videoType || "youtube";
        this.iframeUrl = this.dataset.iframeUrl || "";
        this.shopifyVideoUrl = this.dataset.shopifyVideoUrl || "";
        this.slideInner = this.querySelector(".td-video-testimonials__slide-inner");
        this.modal = null;
        this.modalIframe = null;
        this.modalVideo = null;
      }
  
      connectedCallback() {
        if (this.videoType === "shopify" && !this.shopifyVideoUrl) {
          console.warn("VideoTestimonialCard: No Shopify video URL provided");
          return;
        }
        if (this.videoType !== "shopify" && !this.iframeUrl) {
          console.warn("VideoTestimonialCard: No iframe URL provided");
          return;
        }
  
        const section = this.closest(".td-video-testimonials");
        if (section) {
          this.modal = section.querySelector(".td-video-testimonials__modal");
          if (this.modal) {
            this.modalIframe = this.modal.querySelector(".td-video-testimonials__modal-iframe");
            this.modalVideo = this.modal.querySelector(".td-video-testimonials__modal-video-element");
          }
        }
  
        if (!this.modal) {
          console.warn("VideoTestimonialCard: Modal not found");
          return;
        }
  
        if (this.videoType === "shopify" && !this.modalVideo) {
          console.warn("VideoTestimonialCard: Modal video element not found");
          return;
        }
        if (this.videoType !== "shopify" && !this.modalIframe) {
          console.warn("VideoTestimonialCard: Modal iframe not found");
          return;
        }
  
        this.attachEventListeners();
      }
  
      attachEventListeners() {
        if (this.slideInner) {
          this.slideInner.addEventListener("click", this.handleClick.bind(this));
        }
  
        const closeButton = this.modal.querySelector(".td-video-testimonials__modal-close");
        if (closeButton) {
          closeButton.addEventListener("click", this.closeModal.bind(this));
        }
  
        const overlay = this.modal.querySelector(".td-video-testimonials__modal-overlay");
        if (overlay) {
          overlay.addEventListener("click", this.closeModal.bind(this));
        }
      }
  
      handleClick() {
        this.openModal();
      }
  
      openModal() {
        if (!this.modal) return;
  
        if (this.videoType === "shopify") {
          if (!this.modalVideo) return;
          this.modalIframe.style.display = "none";
          this.modalVideo.style.display = "block";
          this.modalVideo.src = this.shopifyVideoUrl;
          this.modalVideo.load();
          this.modalVideo.play();
        } else {
          if (!this.modalIframe) return;
          this.modalVideo.style.display = "none";
          this.modalIframe.style.display = "block";
          this.modalIframe.src = this.iframeUrl;
        }
  
        this.modal.classList.remove("td-video-testimonials__modal--hidden");
        this.modal.setAttribute("aria-hidden", "false");
  
        const closeButton = this.modal.querySelector(".td-video-testimonials__modal-close");
        if (closeButton) {
          closeButton.focus();
        }
  
        document.body.style.overflow = "hidden";
      }
  
      closeModal() {
        if (!this.modal) return;
  
        if (this.modalIframe) {
          this.modalIframe.src = "";
        }
        if (this.modalVideo) {
          this.modalVideo.pause();
          this.modalVideo.src = "";
        }
  
        this.modal.classList.add("td-video-testimonials__modal--hidden");
        this.modal.setAttribute("aria-hidden", "true");
  
        document.body.style.overflow = "";
  
        if (this.slideInner) {
          this.slideInner.focus();
        }
      }
    }
  
    customElements.define("video-testimonial-card", VideoTestimonialCard);
  }

  } catch(e) { console.error(e); }
})();
})();
